import { render, staticRenderFns } from "./RightDataPlugin.vue?vue&type=template&id=ae72d27e&scoped=true"
import script from "./RightDataPlugin.vue?vue&type=script&lang=js"
export * from "./RightDataPlugin.vue?vue&type=script&lang=js"
import style0 from "./RightDataPlugin.vue?vue&type=style&index=0&id=ae72d27e&prod&lang=css"
import style1 from "./RightDataPlugin.vue?vue&type=style&index=1&id=ae72d27e&prod&scoped=true&lang=css"
import style2 from "./RightDataPlugin.vue?vue&type=style&index=2&id=ae72d27e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae72d27e",
  null
  
)

export default component.exports